import { Model } from '@vuex-orm/core'

export default class UserCourse extends Model {
    
    static entity = 'user_course'
  
    static primaryKey = ['user_id', 'course_id']
  
    static fields () {
        return {
            user_id: this.attr(null),
            course_id: this.attr(null)
        }
    }
}